import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const arrowChooser = ({ theme, position, pointerPosition }) => {
  switch (position) {
    case 'right':
      return `
        border-right: ${theme.spacing(1)} solid #fff;
        right: 99%;
        top: ${pointerPosition};
        transform: translateY(-50%);
      `
    case 'left':
      return `
        border-left: ${theme.spacing(1)} solid #fff;
        left: 99%;
        top: ${pointerPosition};
        transform: translateY(-50%);
      `
    case 'top':
      return `
        border-top: ${theme.spacing(1)} solid #fff;
        top: 99%;
        left: ${pointerPosition};
        transform: translateX(-50%);
      `
    case 'bottom':
      return `
        border-bottom: ${theme.spacing(1)} solid #fff;
        bottom: 99%;
        left: ${pointerPosition};
        transform: translateX(-50%);
      `
  }
}

const animationChooser = ({ theme, position }) => {
  switch (position) {
    case 'right':
    case 'left':
      return theme.animation.swingInHorizontal
    case 'top':
    case 'bottom':
      return theme.animation.swingInVertical
  }
}

const originChooser = ({ theme, position }) => {
  switch (position) {
    case 'right':
      return 'left center'
    case 'left':
      return 'right center'
    case 'top':
      return 'center bottom'
    case 'bottom':
      return 'center top'
  }
}

const PerspectiveContainer = styled.div`
  perspective: 1500px;
  width: ${p => p.theme.mediaSizes.medium * (p.wide ? 0.5 : 0.42)}px;
`

const SpeechBubbleContainer = styled.div`
  animation: ${p => (p.showAnimation ? animationChooser(p) : 'none')};
  animation-delay: ${p =>
    typeof p.animationDelay === 'undefined' ? 1000 : p.animationDelay}ms;
  animation-duration: 0.5s;
  animation-fill-mode: forwards;
  background-color: #fff;
  border-radius: ${p => p.theme.radius(0)};
  box-shadow: 0 0.75rem 1.5rem rgba(0, 0, 0, 0.25);
  color: #3b474c;
  opacity: 0;
  padding: ${p => p.theme.spacing(1)};
  position: relative;
  transform-origin: ${originChooser};
  width: 100%;

  &::after {
    border: ${p => p.theme.spacing(0)} solid transparent;
    content: '';
    display: ${p => (p.showPointer ? 'block' : 'none')};
    height: 0;
    position: absolute;
    width: 0;
    ${arrowChooser};
  }
`

const SpeechBubbleHeading = styled.h3`
  color: #eda44d;
  font-size: ${p => p.theme.fontSize(2.25)};
  line-height: 1;
  margin-bottom: ${p => p.theme.spacing(-1)};
  text-transform: uppercase;
`

const SpeechBubbleContent = styled.div`
  p {
    font-size: ${p => p.theme.fontSize(1.75)};
    line-height: 1;
    margin-bottom: ${p => p.theme.spacing(-1)};

    &:last-child {
      margin-bottom: 0;
    }
  }

  em {
    color: #059ca6;
    text-transform: uppercase;
  }
`

export default class SpeechBubble extends Component {
  static propTypes = {
    animationDelay: PropTypes.number,
    heading: PropTypes.string,
    pointerPosition: PropTypes.string,
    position: PropTypes.oneOf(['left', 'right', 'top', 'bottom']).isRequired,
    showAnimation: PropTypes.bool,
    showPointer: PropTypes.bool,
    wide: PropTypes.bool,
  }

  static defaultProps = {
    animationDelay: 0,
    pointerPosition: '50%',
    showAnimation: true,
    showPointer: true,
    wide: false,
  }

  render() {
    const { className, children, heading, showPointer, ...props } = this.props

    return (
      <PerspectiveContainer className={className}>
        <SpeechBubbleContainer showPointer={showPointer} {...props}>
          {heading && <SpeechBubbleHeading>{heading}</SpeechBubbleHeading>}
          {children && <SpeechBubbleContent>{children}</SpeechBubbleContent>}
        </SpeechBubbleContainer>
      </PerspectiveContainer>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/SpeechBubble.js